<script>
export default {
    setup() {
        const { t } = useI18n();
        const auth = useAuthStore();
        return { t, auth };
    },
    data() {
        return {
            data: {
                oldPassword: '',
                password: '',
                confirmPassword: ''
            }
        };
    },
    computed: {
        passwordMismatch() {
            return this.data.confirmPassword?.length > 0
                && this.data.password !== this.data.confirmPassword;
        },
        canSubmit() {
            return !!this.data.oldPassword
                && !!this.data.password
                && !!this.data.confirmPassword
                && !this.passwordMismatch
                && this.data.password.length >= 12;
        },
    },
    methods: {
        submit() {
            this.auth.changePassword(this.data).then((res) => {
                this.$swal({
                    icon: 'success',
                    position: 'center',
                    showConfirmButton: false,
                    title: this.t('Password has been updated.'),
                    text: res.message,
                    timer: 3000
                });
                this.data.oldPassword = '';
                this.data.password = '';
                this.data.confirmPassword = '';
                UIKit.modal('#modal-change-password').hide();
            });
        }
    }
};
</script>
<template>
    <div id="modal-change-password" class="uk-modal-container" uk-modal>
        <div class="uk-modal-dialog uk-modal-body uk-modal change-password-modal">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <div class="uk-modal-header">
                <h3 class="uk-modal-title">{{ t('Change Password') }}</h3>
            </div>
            <div class="uk-modal-body">
                <FormInput type="password" v-model="data.oldPassword" name="oldPassword"
                    :placeholder="$t('Old Password')" iconLeft="LockCogIcon" size="medium" class="uk-margin" visible />
                <div class="pw-field">
                    <FormInput id="newPassword" type="password" v-model="data.password" name="newPassword"
                        autocomplete="new-password" :placeholder="$t('Password')" iconLeft="LockIcon" size="medium"
                        class="uk-margin" visible />
                    <DropPasswordStrength :password="data.password" target="#newPassword" :min-length="12"
                        pos="right-center" class="pw-hint" />
                </div>
                <FormInput type="password" v-model="data.confirmPassword" name="confirmPassword"
                    autocomplete="new-password" :placeholder="$t('Confirm Password')" iconLeft="LockCogIcon"
                    size="medium" class="uk-margin" visible />
                <p v-if="passwordMismatch" class="uk-text-danger uk-margin-small-top">
                    {{ t('Password confirmation does not match the new password') }}
                </p>
            </div>
            <div class="uk-modal-footer uk-text-right">
                <button class="uk-button uk-button-default uk-modal-close" type="button">{{ t('Cancel') }}</button>
                <button class="uk-button uk-button-primary" @click="submit" :disabled="!canSubmit">{{ t('Save')
                }}</button>
            </div>
        </div>
    </div>
</template>